module.exports = __webpack_public_path__ + "img/ico-juridico.e385a59b.svg";